import axios from 'axios'
import router from '@/router'
import {
    Notification,
    MessageBox
} from 'element-ui'
import {
    getToken, getLang
} from '@/utils/auth'
import Config from '@/config'
// 创建axios实例
const service = axios.create({
    // baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : '/', // api 的 base_url
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (getToken()) {
            //config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
            config.headers['token'] = getToken()
        }
        config.headers['Content-Type'] = 'application/json'
        if (config.method === 'post') {
            config.data = {
                lang: getLang(),
                ...config.data
            }
        } else if (config.method === 'get') {
            config.params = {
                lang: getLang(),
                ...config.params
            }
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        console.log('response=======', response)
        const code = response.status
        if (code < 200 || code > 300) {
            Notification.error({
                title: response.message
            })
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject('error')
        } else {
            let data = response.data;

            if (data.code == -1) {
                Notification.error({
                    title: data.msg,
                    duration: 3000
                })
                router.push({
                    path: '/login'
                })
            } else {
                return response.data
            }

        }
    },
    error => {
        let code = 0
        try {
            code = error.response.data.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                Notification.error({
                    title: 'Network request timeout',
                    // title: '网络请求超时',
                    duration: 2500
                })
                return Promise.reject(error)
            }
            if (error.toString().indexOf('Error: Network Error') !== -1) {
                Notification.error({
                    title: 'Network request error',
                    // title: '网络请求错误',
                    duration: 2500
                })
                return Promise.reject(error)
            }
        }
        if (code === 401) {
            MessageBox.confirm(
                'The login status has expired',
                'System prompt', {
                    confirmButtonText: 'login',
                    cancelButtonText: 'cancel',
                    type: 'warning'
                }
            ).then(() => {
                // store.dispatch('LogOut').then(() => {
                //   location.reload() // 为了重新实例化vue-router对象 避免bug
                // })
                router.push({
                    path: '/login'
                })
            })
        } else if (code === 403) {
            router.push({
                path: '/401'
            })
        } else {
            const errorMsg = error.response.data.message
            if (errorMsg !== undefined) {
                Notification.error({
                    title: errorMsg,
                    duration: 3000
                })
            }
        }
        return Promise.reject(error)
    }
)
export default service
